import { EffectDef, makeGain } from './types';

/**
 * Stereo widener: mid/side split, a short Haas delay on the side signal,
 * then recombine (L = mid + side, R = mid − side). Width scales the delay.
 */
export const widener: EffectDef = {
  type: 'widener',
  name: 'Widener',
  params: [
    { key: 'width', label: 'Width', min: 0, max: 1, default: 0.5, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const splitter = ctx.createChannelSplitter(2);
    const merger = ctx.createChannelMerger(2);

    const midL = makeGain(ctx, 0.5);
    const midR = makeGain(ctx, 0.5);
    const sideL = makeGain(ctx, 0.5);
    const sideR = makeGain(ctx, -0.5);
    const sideDelay = ctx.createDelay(0.05);
    const sideNeg = makeGain(ctx, -1);

    input.connect(splitter);
    splitter.connect(midL, 0);
    splitter.connect(midR, 1);
    splitter.connect(sideL, 0);
    splitter.connect(sideR, 1);

    midL.connect(merger, 0, 0); // L out += mid
    midR.connect(merger, 0, 1); // R out += mid
    sideL.connect(sideDelay, 0);
    sideR.connect(sideDelay, 0);
    sideDelay.connect(merger, 0, 0); // L out += side
    sideDelay.connect(sideNeg, 0);
    sideNeg.connect(merger, 0, 1); // R out −= side

    merger.connect(output);

    const apply = (params: Record<string, number>) => {
      sideDelay.delayTime.setTargetAtTime(params.width * 0.012, ctx.currentTime, 0.05);
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        splitter.disconnect();
        merger.disconnect();
        midL.disconnect();
        midR.disconnect();
        sideL.disconnect();
        sideR.disconnect();
        sideDelay.disconnect();
        sideNeg.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};